import { STORAGE_KEYS } from '@/utils/storageKeys';

/**
 * Location tracking service for managing navigation history
 */
export class LocationTracker {
  private static instance: LocationTracker;
  private currentLocation: string | null = null;

  private constructor() {
    // Initialize with current location if available
    this.currentLocation = sessionStorage.getItem(
      STORAGE_KEYS.PREVIOUS_LOCATION_PATHNAME
    );
  }

  public static getInstance(): LocationTracker {
    if (!LocationTracker.instance) {
      LocationTracker.instance = new LocationTracker();
    }
    return LocationTracker.instance;
  }

  /**
   * Update the current location and store the previous one
   * @param newLocation - The new location pathname
   * @returns The previous location that was stored
   */
  public updateLocation(newLocation: string): string | null {
    const previousLocation = this.currentLocation;

    // Only update if the location has actually changed
    if (previousLocation !== newLocation) {
      this.currentLocation = newLocation;
      sessionStorage.setItem(
        STORAGE_KEYS.PREVIOUS_LOCATION_PATHNAME,
        newLocation
      );
    }

    return previousLocation;
  }

  /**
   * Get the previous location
   * @returns The previous location pathname
   */
  public getPreviousLocation(): string | null {
    return sessionStorage.getItem(STORAGE_KEYS.PREVIOUS_LOCATION_PATHNAME);
  }

  /**
   * Get the current location
   * @returns The current location pathname
   */
  public getCurrentLocation(): string | null {
    return this.currentLocation;
  }

  /**
   * Clear the location history
   */
  public clearHistory(): void {
    this.currentLocation = null;
    sessionStorage.removeItem(STORAGE_KEYS.PREVIOUS_LOCATION_PATHNAME);
  }
}

// Export a singleton instance
export const locationTracker = LocationTracker.getInstance();
